import React from 'react';
import styled from 'styled-components';

import { CtaButton } from '@ui/buttons/Button.tsx';
import { Icon } from '@ui/icons/Icon.tsx';
import Tooltip from '@ui/tooltip';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';
import { handleKeyboardSelect } from '../../../../utils/keyboardUtils.ts';
import HandlerContext from '../handlerContext.tsx';

const ButtonWrapper = styled.div`
  display: flex;
  margin: 12px 0;
  color: ${({ disabled }) => (disabled ? 'var(--color-primaryButtonText-40)' : 'var(--color-primaryButtonText)')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${Icon} {
    margin-inline-end: 8px;
  }
`;

const CtaButtonStyled = styled(CtaButton)`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-radius: ${({ theme }) => theme.standardRadius};
  &:focus-visible {
    outline: 1px solid blue;
    outline-offset: 2px;
  }
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
`;

const GetDirectionsButton = ({ poi, T, searchInputsLength }) => {
  const colors = useCSSColors();
  const maxStopsReached = Boolean(searchInputsLength >= 7);
  return poi.isNavigable ? (
    <HandlerContext.Consumer>
      {ctx => (
        <ButtonWrapper data-testid="GetDirectionsButton" disabled={maxStopsReached}>
          <CtaButtonStyled
            disabled={maxStopsReached}
            onClick={() => {
              ctx.onGetDirectionsClicked();
            }}
            backgroundColor={colors.primaryButton}
            hoverBackgroundColor={colors.primaryButtonHover}
            fontColor={colors.primaryButtonText}
            data-testid="GetDirectionsToPoiButton"
            tabIndex="0"
            aria-label={T('poiView:Get Directions')}
            onKeyDown={handleKeyboardSelect(() => ctx.onGetDirectionsClicked(), { stopPropagation: false })}
          >
            <IconWrapper>
              <Icon name="directions-filled" cdn width={24} height={24} fillColor={colors.primaryButtonText} />
            </IconWrapper>
            <Tooltip text={T('poiView:Maximum Stops Reached')} arrowPosition={'left'} isVisible={maxStopsReached}>
              <span>{searchInputsLength > 1 ? T('poiView:Add Stop') : T('poiView:Get Directions')}</span>
            </Tooltip>
          </CtaButtonStyled>
        </ButtonWrapper>
      )}
    </HandlerContext.Consumer>
  ) : null;
};

export default GetDirectionsButton;
